import actionTypes from "./actionTypes";
import * as userUtils from "../utils/userUtils";

// add odberatel
const addOdberatelRequest = () => ({
  type: actionTypes.CREATE_ORGAN_REQUEST,
});
const addOdberatelSuccess = (res) => ({
  type: actionTypes.CREATE_ORGAN_SUCCESS,
  res,
});
const addOdberatelFailure = (error) => ({
  type: actionTypes.CREATE_ORGAN_FAILURE,
  error,
});
export const addOdberatel = (data) => {
  return async (dispatch) => {
    try {
      dispatch(addOdberatelRequest());
      let res = await userUtils.addOdberatel(data);
      dispatch(addOdberatelSuccess(res));
    } catch (error) {
      dispatch(addOdberatelFailure(error));
    }
  };
};

// update user
const updateUserSuccess = (res) => ({
  type: actionTypes.UPDATE_USER_SUCCESS,
  res,
});
const updateUserRequest = () => ({
  type: actionTypes.UPDATE_USER_REQUEST,
});
const updateUserFailure = (error) => ({
  type: actionTypes.UPDATE_USER_FAILURE,
  error,
});
export const updateUser = (data) => {
  return async (dispatch) => {
    try {
      dispatch(updateUserRequest());
      let res = await userUtils.updateUser(data);
      dispatch(updateUserSuccess(res));
    } catch (error) {
      dispatch(updateUserFailure(error));
    }
  };
};
